import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '@pt/environment';
import { Language, Preferences } from '@pt/models';
import { Observable } from 'rxjs';

import { UpdatePreferencesReq } from './preferences.abstraction';
import { getLanguagesMock, getUserPreferencesMock } from './mocks/preferences-mock';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService {
  #http = inject(HttpClient);

  getPreferences(): Observable<Preferences> {
    if (environment.useMocks) {
      return getUserPreferencesMock();
    }

    return this.#http.get<Preferences>(`${environment.apiHost}user-preferences/`);
  }

  getLanguages(): Observable<Language[]> {
    if (environment.useMocks) {
      return getLanguagesMock();
    }

    return this.#http.get<Language[]>(`${environment.apiHost}structure/languages/`);
  }

  updatePreferences(preferences: UpdatePreferencesReq): Observable<Preferences> {
    if (environment.useMocks) {
      return getUserPreferencesMock();
    }

    return this.#http.patch<Preferences>(`${environment.apiHost}user-preferences/`, preferences);
  }
}
